import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation('common');

  const footerLinks = {
    product: [
      t('footer.product.features'),
      t('footer.product.scenarios'),
      // t('footer.product.pricing'),
      t('footer.product.security')
    ],
    resources: [
      t('footer.resources.api'),
      // t('footer.resources.sdk'),
      t('footer.resources.guide'),
      // t('footer.resources.blog')
    ],
    company: [
      t('footer.company.about'),
      t('footer.company.privacy'),
      t('footer.company.terms'),
      t('footer.company.contact')
    ]
  };

  const socialLinks = [
    { icon: 'ri-twitter-line', name: 'Twitter', url: '#' },
    { icon: 'ri-telegram-line', name: 'Telegram', url: 'https://t.me/coolpaylink' },
    { icon: 'ri-discord-line', name: 'Discord', url: '#' },
    { icon: 'ri-github-line', name: 'GitHub', url: '#' }
  ];

  return (
    <footer className="bg-slate-900 border-t border-slate-800 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_25%_25%,rgba(6,182,212,0.05),transparent_50%)]"></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-6">
        {/* Main Footer Content */}
        <div className="py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Section */}
          <div className="lg:col-span-1">
            <div className="flex items-center space-x-2 mb-6">
              <img 
                src="/images/coolpay-logo.png" 
                alt="CoolPay" 
                className="w-8 h-8"
              />
              <span className="text-2xl font-bold bg-gradient-to-r from-cyan-400 to-blue-500 bg-clip-text text-transparent">
                CoolPay
              </span>
            </div>
            
            <p className="text-gray-300 leading-relaxed mb-6 max-w-xs">
              {t('footer.slogan')}
            </p>

            {/* Social Links */}
            <div className="flex space-x-4">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.url}
                  className="w-10 h-10 bg-slate-800 border border-slate-700 rounded-lg flex items-center justify-center text-gray-400 hover:text-cyan-400 hover:border-cyan-500/50 hover:bg-slate-700 transition-all duration-300"
                  aria-label={social.name}
                >
                  <i className={`${social.icon} text-lg`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Product Links */}
          <div>
            <h3 className="text-lg font-semibold text-white mb-6">
              {t('footer.product.title')}
            </h3>
            <ul className="space-y-4">
              {footerLinks.product.map((link, index) => (
                <li key={index}>
                  <button className="text-gray-300 hover:text-cyan-400 transition-colors duration-300 text-left">
                    {link}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources Links */}
          <div>
            <h3 className="text-lg font-semibold text-white mb-6">
              {t('footer.resources.title')}
            </h3>
            <ul className="space-y-4">
              {footerLinks.resources.map((link, index) => (
                <li key={index}>
                  <button className="text-gray-300 hover:text-cyan-400 transition-colors duration-300 text-left">
                    {link}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Links */}
          <div>
            <h3 className="text-lg font-semibold text-white mb-6">
              {t('footer.company.title')}
            </h3>
            <ul className="space-y-4">
              {footerLinks.company.map((link, index) => (
                <li key={index}>
                  <button className="text-gray-300 hover:text-cyan-400 transition-colors duration-300 text-left">
                    {link}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="py-6 border-t border-slate-800">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-gray-400 text-sm">
              {t('footer.copyright')}
            </div>
            
            <div className="flex items-center space-x-6">
              <button className="text-gray-400 hover:text-cyan-400 text-sm transition-colors duration-300">
                {t('footer.company.privacy')}
              </button>
              <button className="text-gray-400 hover:text-cyan-400 text-sm transition-colors duration-300">
                {t('footer.company.terms')}
              </button>
              <a 
                href="https://readdy.ai/?origin=logo" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-cyan-400 text-sm transition-colors duration-300"
              >
                {t('footer.poweredBy')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;